import React, { useState } from "react";
import { Slide, Fade } from "react-awesome-reveal";
import { TbPlus, TbMinus } from "react-icons/tb";
import "../../styles/FAQ.css";

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const faqs = [
  {
    id: 1,
    question: "¿Cuánto cuesta?",
    answer:
      "No existe un precio único porque cada operación es distinta. El costo depende del alcance, los módulos que necesitás y el nivel de integración. Lo que sí podemos decir: trabajamos con presupuestos transparentes, sin sorpresas, y orientados a que el retorno supere la inversión en los primeros meses. El primer paso — el diagnóstico estratégico — es gratuito.",
  },
  {
    id: 2,
    question: "¿Cuánto tarda la implementación?",
    answer:
      "Un módulo ERP o MES inicial puede estar en producción en 2 a 4 semanas. Implementamos por fases para que tu equipo adopte el cambio sin interrumpir la operación. El Gemelo Digital y los desarrollos a medida tienen timelines propios que definimos juntos en el roadmap. La velocidad depende de la claridad del alcance — por eso empezamos con un diagnóstico.",
  },
  {
    id: 3,
    question: "¿Se integra con los sistemas que ya tenemos?",
    answer:
      "Sí. Una parte central de nuestro trabajo es la integración con lo que ya existe: ERPs legacy, bases de datos, PLCs, sensores, planillas de Excel, APIs externas. No te pedimos que tires lo que funciona — construimos sobre eso y lo conectamos de forma inteligente.",
  },
  {
    id: 4,
    question: "¿Es escalable si crecemos?",
    answer:
      "Está diseñado para escalar. La arquitectura modular permite arrancar con lo esencial e ir sumando funcionalidades, plantas, usuarios o integraciones a medida que tu operación crece. No comprás más de lo que necesitás hoy, pero el sistema no te limita mañana.",
  },
  {
    id: 5,
    question: "¿Trabajan solo con industria?",
    answer:
      "No. Tenemos experiencia tanto en empresas industriales (manufactura, planta, producción) como en pymes de servicios, retail, gastronomía y startups de tecnología. Lo que todas tienen en común es que operan con procesos y datos que pueden gestionarse mejor. Si eso aplica a tu negocio, podemos ayudarte.",
  },
];

/* ─────────────────────────────────────────────
   ACCORDION ITEM
───────────────────────────────────────────── */
const FAQItem = ({ faq, isOpen, onToggle, index }) => (
  <Fade delay={index * 80} duration={500} direction="up" triggerOnce>
    <div
      className={`faq-item${isOpen ? " faq-item--open" : ""}`}
      onClick={onToggle}
    >
      <div className="faq-question">
        <span>{faq.question}</span>
        <div className="faq-icon">
          {isOpen ? <TbMinus size={18} /> : <TbPlus size={18} />}
        </div>
      </div>

      {/* Answer panel — pure CSS height transition via max-height */}
      <div className="faq-answer-wrap">
        <p className="faq-answer">{faq.answer}</p>
      </div>
    </div>
  </Fade>
);

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="faq-section" id="faq">
      <div className="container py-5">

        {/* ── Header ── */}
        <Slide direction="up" duration={700} triggerOnce>
          <div className="text-center mb-5">
            <span className="eco-badge">FAQ</span>
            <h2 className="eco-main-title text-white mt-3">
              Preguntas frecuentes
            </h2>
            <p className="eco-main-sub text-white-50">
              Respuestas directas a lo que más nos preguntan antes de arrancar.
            </p>
          </div>
        </Slide>

        {/* ── Accordion ── */}
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <FAQItem
              key={faq.id}
              faq={faq}
              index={i}
              isOpen={openId === faq.id}
              onToggle={() => toggle(faq.id)}
            />
          ))}
        </div>

        {/* ── CTA below ── */}
        <Fade delay={500} duration={700} triggerOnce>
          <div className="faq-cta">
            <p className="text-white-50 mb-3">¿No encontrás lo que buscás?</p>
            <a
              href="mailto:sales@twinexa.com?subject=Consulta general&body=Hola, tengo una consulta sobre los servicios de Twinexa."
              className="btn btn-connect"
            >
              Hablemos →
            </a>
          </div>
        </Fade>

      </div>
    </section>
  );
};

export default FAQ;
